import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { RxHamburgerMenu } from "react-icons/rx";
import { MdOutlineClose } from "react-icons/md";
import { NavLink } from "react-router-dom";
import { logo, profile, sun } from "../../images/images";
import styles from "./styles.module.css";
import { useWeb3Modal } from "@web3modal/react";
import { useAccount } from "wagmi";

const Navbar = () => {
  const { open } = useWeb3Modal();
  const { address } = useAccount();
  const [sidebar, setSidebar] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const navItems = [
    { navItem: "Home", to: "https://uns.technology" },
    { navItem: "Leaderboard", to: "/leaderboard", nav: true },
    { navItem: "Staking", to: "/", nav: true },
    { navItem: "Shop", to: "https://shop.uns.technology" },
    { navItem: "Buy UNS", to: "https://sale.uns.technology" },
  ];

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      if (scrollPosition >= 90) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Clean up event listener
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <section className={`${styles.navbar} ${isScrolled && styles.navBg}`}>
      <div className="container">
        <div className={styles.navs}>
          <div className={styles.logoContainer}>
            <img src={logo} alt="#" width="120px" className={styles.logo} />
            <p className={styles.logoText}></p>
          </div>
          <div
            className={`${styles.navItemsAndButtons} ${sidebar && styles.sidebar
              }`}
          >
            <div className={`${styles.navItems} `}>
              {navItems.map((el, i) => (
                <NavLink
                  onClick={() => setSidebar((prev) => !prev)}
                  to={el.to}
                  key={i}
                  className={({ isActive }) =>
                    isActive ? styles.navItemActive : styles.navItem
                  }
                >
                  {el.navItem}
                </NavLink>
              ))}
              {sidebar && (
                <MdOutlineClose
                  className={styles.close}
                  onClick={() => setSidebar((prev) => !prev)}
                />
              )}
            </div>
            <div className={styles.buttonContainer}>
              {/* <Link to="/" className={styles.iconContainer}>
                <img src={profile} alt="#" className={styles.icon} />
              </Link>{" "} */}
              {/* <Link to="/" className={styles.iconContainer}>
                <img src={sun} alt="#" className={styles.icon} />
              </Link> */}
              <a onClick={open} className={styles.button}>
                <span className={styles.buttonText}>
                  {address ? "Connected" : "Connect Wallet"}
                </span>
              </a>{" "}
            </div>
          </div>{" "}
        </div>
      </div>{" "}
      <RxHamburgerMenu
        className={styles.hamburger}
        onClick={() => setSidebar((prev) => !prev)}
      />
    </section>
  );
};

export default Navbar;
